import axios from './axios';

export default {
  get: async params => {
    const { data } = await axios.get('/accounts', { params });
    return data;
  },

  getById: async (id, params) => {
    const { data } = await axios.get(`/accounts/${id}`, {
      params
    });
    return data;
  },

  update: async (id, body, query) => {
    const params = { params: query };
    const { data } = await axios.put(`/accounts/${id}`, body, params);
    return data;
  },

  changePassword: async body => {
    const { data } = await axios.post('/accounts/change-password', body);
    return data;
  },

  resetPassword: async body => {
    const { data } = await axios.post('/accounts/reset/password', body);
    return data;
  },

  getByToken: async token => {
    const { data } = await axios.get(`/accounts/reset/password/${token}`);
    return data;
  },

  updatePassword: async (token, body) => {
    const { data } = await axios.post(
      `/accounts/reset/password/${token}`,
      body
    );
    return data;
  },

  create: async body => {
    const { data } = await axios.post('/accounts/signup/create-account', body);
    return data;
  },

  getNewInformation: async token => {
    const { data } = await axios.get(`/accounts/signup/${token}`);
    return data;
  },

  confirmRegistration: async (language, token, body) => {
    const { data } = await axios.post(
      `/accounts/signup/confirm-registration/${language}/${token}`,
      body
    );
    return data;
  },

  resendConfirmationEmail: async (username, language) => {
    const params = { params: { username } };
    const { data } = await axios.get(
      `/accounts/resend-confirmation-email/${language}`,
      params
    );
    return data;
  },

  postponePasswordChange: async () => {
    const { data } = await axios.put(`/accounts/change-password/postpone`);
    return data;
  }
};
